module.exports = __webpack_public_path__ + "img/18-detail.5dd7d356.png";